// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NxZzy","label":"styles_label__Cbaj8"};